import React, { useContext, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import { UploadCore } from '@/components/upload-core';
import { UploadContext, UploadStateContext, } from '@/components/upload-core/context';
import { UploadList } from './upload-list';
import { acceptList } from '../../constant/accept-list';
import './index.scss';
const View = () => {
    const { limit, value, readOnly } = useContext(UploadStateContext);
    const comRef = useRef(null);
    const [itemSize, setItemSize] = useState(0);
    const itemStyle = useMemo(() => ({ width: itemSize, height: itemSize }), [itemSize]);
    useLayoutEffect(() => {
        if (!comRef.current)
            return;
        const rect = comRef.current.getBoundingClientRect();
        setItemSize((prev) => {
            if (prev)
                return prev;
            const _itemSize = (rect.width - 12 * 3) / 4;
            if (_itemSize > 80)
                return 80;
            return _itemSize;
        });
    }, []);
    const hideAddStyle = limit && limit <= value.length ? { display: 'none' } : {};
    return (React.createElement("div", { ref: comRef, className: "cn-ui-m-oss-image-upload-box" },
        React.createElement("div", { className: classNames('cn-ui-m-oss-image-upload', {
                'cn-ui-m-oss-image-upload-readonly': readOnly,
            }) },
            React.createElement(UploadList, { style: itemStyle }),
            readOnly ? null : (React.createElement("div", { className: "cn-ui-m-oss-image-upload-item cn-ui-m-oss-image-upload-add", style: { ...itemStyle, ...hideAddStyle } },
                React.createElement(UploadCore, { className: "cn-ui-m-oss-image-upload-add-inner" },
                    React.createElement(CnIcon, { type: "add", size: "xl" })))))));
};
export const OSSImageUpload = (props) => {
    return (React.createElement(UploadContext, { ...props, accept: acceptList.join(', ') },
        React.createElement(View, null)));
};
